import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userlayout',
  templateUrl: './userlayout.component.html',
  styleUrls: ['./userlayout.component.scss']
})
export class UserlayoutComponent implements OnInit {
  selectedColor = "white";
  noramalColor = "#4F94D3"
  constructor() { }

  ngOnInit(): void {
  }

}
